

export const recentCustomers = (
    { setModalData }: {
        setModalData?: (data: { modalType: string; data: { id: number | undefined } }) => void
    }) => {
    return [
        {
            Header: "Created At",
            accessor: (row: any) => new Date(row?.created_at),
            Cell: ({ row }: any) => {

                const date = row.original.created_at;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {date ? new Date(date).toLocaleDateString("de") : "Not available"}
                    </span>
                );
            },
            id: 5,
            isChecked: true,
        },
        {
            Header: "Name",
            accessor: "first_name",
            Cell: ({ row }: any) => {

                const { first_name, last_name } = row.original;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {first_name} {last_name}
                    </span>
                );
            },
            id: 1,
            isChecked: true,
        },
        {
            Header: "Birthdate",
            accessor: (row: any) => row?.birthdate ? new Date(row?.birthdate) : 'birthdate',
            Cell: ({ row }: any) => {

                const birthdate = row.original.birthdate;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {birthdate ? new Date(birthdate).toLocaleDateString("de") : "Not available"}
                    </span>
                );
            },
            id: 2,
            isChecked: true,
        },
        {
            Header: "Address",
            accessor: "address",
            Cell: ({ row }: any) => {

                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {row.original.address || "Not available"}
                    </span>
                );
            },
            id: 6,
            isChecked: true,
        },
        {
            Header: "Email",
            accessor: "email",
            Cell: ({ row }: any) => {

                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {row.original.email || "Not available"}
                    </span>
                );
            },
            id: 3,
            isChecked: true,
        },
        {
            Header: "Phone",
            accessor: "phone",
            Cell: ({ row }: any) => {

                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "customers", data: { id: row.original.id } })}
                    >
                        {row.original.phone || "Not available"}
                    </span>
                );
            },
            id: 4,
            isChecked: true,
        }
    ];
}
